import { HrefLangType } from '@/store/hrefLang/hrefLang.interface';
import { HREFLANG_DEFAULT_LANG_ISO } from '@/utils/constants';

const BASE_URL_SUFFIX = /\/site/.test(window?.location?.href) ? '/site' : '';
const BASE_URL = `${window?.location?.origin}${BASE_URL_SUFFIX}`;

interface FetchProps {
  hrefLangs: Record<string, string>;
  whitelist: string[];
}
export const format = ({ hrefLangs = {}, whitelist = [] }: FetchProps): HrefLangType[] => {
  try {
    const reducedHreflangs = Object.keys(hrefLangs).reduce((prev: HrefLangType[], curr: string) => {
      if (!whitelist.includes(curr)) return [...prev];

      return [...prev, { hreflang: curr, href: `${BASE_URL}${hrefLangs?.[curr]?.toLowerCase()}` }];
    }, []);

    if (hrefLangs?.[HREFLANG_DEFAULT_LANG_ISO])
      return [
        ...reducedHreflangs,
        {
          hreflang: 'x-default',
          href: `${BASE_URL}${hrefLangs?.[HREFLANG_DEFAULT_LANG_ISO]?.toLowerCase()}`,
        },
      ];

    return reducedHreflangs;
  } catch (error) {
    return [];
  }
};

const SEPARATOR = ',';
export const getExclusionPaths = (paths = '') => {
  if (!paths?.trim()?.length) return [];

  return paths.split(SEPARATOR).map((path) => path?.trim());
};

interface IsPathExcludedProps {
  path: string;
  pathsToExclude: string[];
}
export const isPathExcluded = ({ path = '', pathsToExclude = [] }: IsPathExcludedProps) => {
  if (!pathsToExclude.length) return false;

  return pathsToExclude.some((pathExcluded: string) => RegExp(pathExcluded, 'i').test(path));
};
